import { QUICK_INFO_BUTTONS } from '@aibees/elephant/components/quick-info-group/components/quick-info-button';
import { useActionButtonContext } from '@aibees/elephant/context/action-button-context';
import { useSaveRecord } from '@aibees/elephant/hooks/use-save-record';
import { SearchType } from '@aibees/elephant/types';
import { useMemo } from 'react';
import { isVerifyingEmails } from '../components/people-email-popover/utils';
import { PeopleTableInfo } from '../types';

export function useIsVerifyingEmails(item?: PeopleTableInfo) {
  const api = useSaveRecord(SearchType.People);
  const { isItemProcessing } = useActionButtonContext();

  const isVerifying = useMemo(() => {
    const contextLoading = isItemProcessing({
      id: item?.id ?? '',
      type: QUICK_INFO_BUTTONS.EMAIL_ENRICHMENT,
    });

    if (api.isLoading || isVerifyingEmails(item) || contextLoading) return true;

    return false;
  }, [api.isLoading, item, isItemProcessing]);

  return { isVerifying };
}
